import { render, staticRenderFns } from "./dropdown-page.html?vue&type=template&id=fcb52916&scoped=true&"
import script from "./dropdown-page.js?vue&type=script&lang=js&"
export * from "./dropdown-page.js?vue&type=script&lang=js&"
import style0 from "./dropdown-page.css?vue&type=style&index=0&id=fcb52916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb52916",
  null
  
)

export default component.exports